
import React, { useState } from 'react';
import faqData from '../../data/faqData.json';
import {  Card, CardBody, CardHeader } from '../../components/card/card';
import NormalInput from '../../components/form/HorizontalNormalInput';
import NormalTextArea from '../../components/form/HorizontalNormalTextarea';
import LoadingIndicator from '../../components/LoadingIndicator';
import { getEmptyField } from '../../utils/helper';
import { toast } from 'react-toastify';
import { faq } from '../../api';
function FaqList() {
    const [activeKey, setActiveKey] = useState(null);
    const [loading, setLoading] = useState(false);
    const [emptyField, setEmptyField] = useState([]);
    
    const [payload, setPayload] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setPayload({ ...payload, [e.target.name]: e.target.value });
    };

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const handleSubmit = async () => {
   
    const mandatory = ['name','email','subject','message']
    const ef = getEmptyField(payload, mandatory)
    setEmptyField(ef)
    if (ef.length > 0) {
      toast.error("Mandatory field must be filled");
      return;
    }

      try {
        setLoading(true);
        const res = await faq.create(payload);
        if (res.ok) {
          toast.success("Successfully Submitted");
          setPayload({
            name: '',
            email: '',
            subject: '',
            message: ''
          });
        }
      } catch (e) {
          console.log(e);
        toast.error('Something went wrong, please try again');
      } finally {
        setLoading(false);
      }
  
    
  };

return (
      <div className="container">
          <LoadingIndicator open={loading} />
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">FAQ</a>
            </li>
            <li className="breadcrumb-item active">FAQ</li>
          </ul>

          {/* FAQ Title */}
          <div className="text-center my-5">
            <h3 className="fw-bold text-muted ">Frequently Asked Questions</h3>
          </div>

          {/* FAQ Accordion */}
          <div className="faq-container">
            {faqData.faqs.map((faq, index) => (
              <div key={faq.id} className="faq-item mb-3">
                <div 
                  className={`faq-question ${activeKey === index ? 'active' : ''}`}
                  onClick={() => handleToggle(index)}
                  style={{
                    padding: '20px 25px',
                
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <h5 className="mb-0 fw-normal" style={{ fontSize: '16px' }}>
                    {faq.question}
                  </h5>
                  <span 
                    className="toggle-icon"
                    style={{
                      fontSize: '24px',
                      color: '#666',
                      transform: activeKey === index ? 'rotate(45deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease'
                    }}
                  >
                    +
                  </span>
                </div>
                
                {activeKey === index && (
                  <div 
                    className="faq-answer"
                    style={{
                      padding: '20px 25px',
              
                      border: '1px solid #e0e0e0',
                      borderTop: 'none',
                      borderRadius: '0 0 8px 8px',
                      marginTop: '-1px',
                      animation: 'fadeIn 0.3s ease'
                    }}
                  >
                    <p className="mb-0 text-muted" style={{ lineHeight: '1.6' }}>
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

                  <div className='mt-5'>
                      
                      <Card>
                          <CardHeader>
                              Ask a Question
                          </CardHeader>
                          <CardBody>
                              
                              <div>
                                  <NormalInput emptyField={emptyField} required type="text" label="Name" name="name" value={payload.name} onchange={handleChange} />
                              </div>

                              <div>
                                  <NormalInput emptyField={emptyField} required type="email" label="Email" name="email" value={payload.email} onchange={handleChange} />
                              </div>

                              <div>
                                  <NormalInput emptyField={emptyField} required type="text" label="Subject" name="subject" value={payload.subject} onchange={handleChange} />
                              </div>

                              <div>
                                  <NormalTextArea emptyField={emptyField} required type="text" label="Message" name="message" value={payload.message} onchange={handleChange} />
                              </div>

                              <div>
                                  <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>{loading ? "Submitting..." : "Submit Question"}</button>
                              </div>
                              
                          </CardBody>
                          
                      </Card>
                  </div>

          {/* Custom CSS for animations */}
          <style jsx>{`
            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(-10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
            
            .faq-question:hover {
              box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
              transform: translateY(-2px);
            }
            
            .faq-question.active {
              border-bottom-left-radius: 0 !important;
              border-bottom-right-radius: 0 !important;
            }
          `}</style>
        </div>
      </div>
    </div>
  );
}

export default FaqList;
